export const SET_IS_CLASSIC_THEME = "SET_IS_CLASSIC_THEME" as "SET_IS_CLASSIC_THEME";

export type ThemeAction = | { type: typeof SET_IS_CLASSIC_THEME; isClassicTheme: boolean };
